/*
 * Copyright (C) 2018 BarD Software s.r.o
 */

import {Vue, Component} from 'vue-facing-decorator';
import {Prop} from 'vue-facing-decorator';
import {updateDependencies} from '../Dashboard';
import {loadTeam, ProjectDto, TeamDto} from '../Teams';
import {handleXhrError} from '../utils/Ui';
import {ProjectRemove} from '../ProjectRoutes';

import $ from 'jquery';

@Component
export default class ProjectRemoveModal extends Vue {
    @Prop()
    public team: TeamDto;

    @Prop()
    public project: ProjectDto;

    public remove() {
        ProjectRemove.invoke({ projectRefid: this.project.refid })
            .then(() => {
                const promiseGetTeam = loadTeam(this.team.refid);
                $(this.$el).modal('hide');
                return promiseGetTeam;
            })
            .then(updateDependencies)
            .fail((jqXhr) => handleXhrError(jqXhr, 'can\'t remove project'));
    }
}
